import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { SiteModel } from 'src/app/models/site.model';
import { ApiRequestService } from 'src/app/shared/api-request.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { RBACService } from '../../../shared/rbac.service';

@Component({
  selector: 'app-sites-noticeboard-view',
  templateUrl: './sites-noticeboard-view.component.html',
  styleUrls: ['./sites-noticeboard-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SitesNoticeboardViewComponent implements OnInit {
  // the site model placeholder
  site: SiteModel = new SiteModel();

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public app: AppService,
    private api: ApiRequestService,
    public utils: UtilsService,
    public rbac: RBACService
  ) {}

  ngOnInit(): void {
    if (
      !this.rbac.userCanAccess([
        RBACService.getPermission(
          RBACService.RBAC_F.F_SITES,
          RBACService.RBAC_A.A_VIEW
        )
      ])
    ) {
      this.rbac.showGenericAccessDeniedMessage();
      this.router.navigate(['/sites']);
      return;
    }

    // Get the site id from the route params.
    const parent_id: number = Number(
      this.route.parent.snapshot.params['parent_id']
    );
    const child_id: number = Number(
      this.route.parent.snapshot.params['child_id']
    );

    // Check if we are updating a site or creating a new one.
    if (
      child_id ||
      (typeof this.route.parent.snapshot.params['child_id'] == 'undefined' &&
        parent_id)
    ) {
      // Store the site id.
      this.site.id = child_id ? child_id : parent_id;

      this.api
        .makeRequest('get', 'v1/sites/' + this.site.id)
        .then(
          (response: any): void => {
            // apply the site response data
            this.site.apply(response.data);
          }
        )
        .catch(
          (err: any): void => {
            this.utils.showModal('Error', err.error.message);
          }
        );
    }
  }

  protected readonly RBACService = RBACService;
}
